import "../../components/App.css";
import React, { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import {
  TextField,
  Select,
  MenuItem,
  InputLabel,
  Button,
  Grid,
  Typography,
} from "@mui/material";
import { Alert, Spinner } from "react-bootstrap";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import countryToCurrency from "country-to-currency";
import axios from "axios";
import { API_BASE_URL } from "../../config/config";
import CaptchaField from "../../components/CaptchaField";
import { Link } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import CarePlanPaymentHandler from "../../components/Payment/CarePlanPaymentHandler";

const EventsCarePlan = ({ userDetails }) => {
  const [currencies, setCurrencies] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [selectedEventInvite, setSelectedEventInvite] = useState(null);
  const [recaptchaToken, setRecaptchatToken] = useState("");
  const [user, setUser] = useState(null);

  useEffect(() => {
    const currencies = Object.values(countryToCurrency);
    const currency = [...new Set(currencies)];
    setCurrencies(currency);
  }, []);

  useEffect(() => {
    const currencies = Object.values(countryToCurrency);
    const currency = [...new Set(currencies)];
    setCurrencies(currency);
  }, []);

  const handleEventInviteChange = (event) => {
    const file = event.target.files[0];
    setSelectedEventInvite(file);
  };

  const calculateCareValues = (values) => {
    const carePercentage = 0.01;
    values.careFees = (
      parseFloat(values.careValueAmount) * carePercentage
    ).toFixed(2);
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const formData = new FormData();

      formData.append("email", userDetails.email);
      formData.append("password", userDetails.password);
      formData.append("fName", userDetails.fName);
      formData.append("mName", userDetails.mName);
      formData.append("lName", userDetails.lName);
      formData.append("country", userDetails.country);
      formData.append("state", userDetails.state);
      formData.append("city", userDetails.city);
      formData.append("zip", userDetails.zip);
      formData.append("contact", userDetails.contact);

      values.services.forEach((service, index) => {
        calculateCareValues(service);

        formData.append("eventInvite", selectedEventInvite);

        Object.entries(service).forEach(([key, value]) => {
          if (key !== "eventInvite") {
            formData.append(`services[${index}][${key}]`, value);
          }
        });
      });

      Object.keys(values).forEach((key) => {
        if (key !== "services") {
          formData.append(key, values[key]);
        }
      });

      formData.append("recaptchaToken", recaptchaToken);

      console.log(values);

      await axios.post(
        `${API_BASE_URL}/register`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      const token = localStorage.getItem("care_token");
      const tokenData = jwtDecode(token);
      const userId = tokenData.userId;
      const response = await axios.get(
        `${API_BASE_URL}/user?userId=${userId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setUser(response.data.user);
    } catch (error) {
      console.error("Error:", error.response?.data?.error || error.message);
      setError("Error submitting the form");
    } finally {
      setLoading(false);
      setSubmitting(false);
    }
  };

  const handleCaptchaChange = (token) => {
    if (token) {
      setRecaptchatToken(token);
    }
  };

  return (
    <div>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DemoContainer components={["DatePicker"]}>
          <Formik
            initialValues={{
              services: [
                {
                  type: "Events",
                  category: "",
                  eventDetails: "",
                  eventDays: "",
                  expectedAttendees: "",
                  eventVenue: [],
                  emergencyContact: "",
                  eventInvite: "",
                  referralCode: "",
                  currency: "",
                  careFees: 0,
                  careValueAmount: 0,
                  careExpireTimeline: "1 Year",
                },
              ],
            }}
            onSubmit={handleSubmit}
          >
            {(formik) => (
              <Form>
                {formik.values.services.map((service, index) => (
                  <div key={index}>
                    <Grid container spacing={2} style={{ marginTop: 0 }}>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].category`}>
                          Select Product Category
                        </InputLabel>
                        <Field
                          as={Select}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].category`}
                          id={`services[${index}].category`}
                        >
                          <MenuItem value="Wedding">Wedding</MenuItem>
                          <MenuItem value="Corporate Events">
                            Corporate Events
                          </MenuItem>
                          <MenuItem value="Private Events">
                            Private Events
                          </MenuItem>
                        </Field>
                        <ErrorMessage name={`services[${index}].category`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].eventDetails`}>
                          Event Details
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].eventDetails`}
                          id={`services[${index}].eventDetails`}
                        />
                        <ErrorMessage
                          name={`services[${index}].eventDetails`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].eventDays`}>
                          Event Days
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].eventDays`}
                          id={`services[${index}].eventDays`}
                        />
                        <ErrorMessage name={`services[${index}].eventDays`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          htmlFor={`services[${index}].expectedAttendees`}
                        >
                          Expected Number of Attendees
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].expectedAttendees`}
                          id={`services[${index}].expectedAttendees`}
                        />
                        <ErrorMessage
                          name={`services[${index}].expectedAttendees`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <InputLabel htmlFor={`services[${index}].eventVenue`}>
                          Event Venue
                        </InputLabel>
                        {service.eventVenue.map((venue, venueIndex) => (
                          <div key={venueIndex}>
                            <Field
                              as={TextField}
                              style={{ width: "100%", marginBottom: "20px" }}
                              size="small"
                              name={`services[${index}].eventVenue[${venueIndex}]`}
                              id={`services[${index}].eventVenue[${venueIndex}]`}
                              value={venue}
                            />
                          </div>
                        ))}
                        <Button
                          type="button"
                          onClick={() =>
                            formik.setFieldValue(
                              `services[${index}].eventVenue`,
                              [...service.eventVenue, ""]
                            )
                          }
                          color="primary"
                          variant="contained"
                        >
                          Add More
                        </Button>
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          htmlFor={`services[${index}].emergencyContact`}
                        >
                          Emergency Contact Person Details
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].emergencyContact`}
                          id={`services[${index}].emergencyContact`}
                        />
                        <ErrorMessage
                          name={`services[${index}].emergencyContact`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].eventInvite`}>
                          Event Invite
                        </InputLabel>
                        <input
                          style={{ width: "100%" }}
                          size="small"
                          type="file"
                          name={`services[${index}].eventInvite`}
                          id={`services[${index}].eventInvite`}
                          onChange={handleEventInviteChange}
                          required
                        />
                        <ErrorMessage name={`services[${index}].eventInvite`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel htmlFor={`services[${index}].currency`}>
                          Select Currency
                        </InputLabel>
                        <Field
                          as={Select}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].currency`}
                          id={`services[${index}].currency`}
                        >
                          <MenuItem value="">Select Currency</MenuItem>
                          {currencies.map((currency) => (
                            <MenuItem key={currency} value={currency}>
                              {currency}
                            </MenuItem>
                          ))}
                        </Field>
                        <ErrorMessage name={`services[${index}].currency`} />
                      </Grid>
                      <Grid item xs={12} sm={6}>
                        <InputLabel
                          htmlFor={`services[${index}].careValueAmount`}
                        >
                          Enter Care Value
                        </InputLabel>
                        <Field
                          as={TextField}
                          style={{ width: "100%" }}
                          size="small"
                          name={`services[${index}].careValueAmount`}
                          id={`services[${index}].careValueAmount`}
                        />
                        <ErrorMessage
                          name={`services[${index}].careValueAmount`}
                        />
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <InputLabel
                          htmlFor={`services[${index}].careFees`}
                          align="center"
                        >
                          Care Fees to Pay
                        </InputLabel>
                        <Typography
                          variant="h6"
                          align="center"
                          name={`services[${index}].careFees`}
                        >
                          {service.careValueAmount &&
                            `${(service.careValueAmount * 0.01).toFixed(2)} ${
                              service.currency
                            }`}
                        </Typography>
                      </Grid>
                      <Grid item xs={12} sm={12}>
                        <InputLabel
                          htmlFor={`services[${index}].careValueAmount`}
                          align="center"
                        >
                          Your Care Value for 1st Year will be
                        </InputLabel>
                        <Typography
                          variant="body1"
                          align="center"
                          name={`services[${index}].careValueAmount`}
                          id={`services[${index}].careValueAmount`}
                        >
                          {service.careValueAmount} {service.currency}
                        </Typography>
                      </Grid>
                    </Grid>
                  </div>
                ))}
                <CaptchaField
                  onChange={handleCaptchaChange}
                  wrapperStyle={{ display: "flex" }}
                  style={{
                    margin: "0 auto",
                    textAlign: "center",
                    marginTop: "2rem",
                  }}
                />
                <div className="submission-popup">
                  <div className="loading">
                    {loading && <Spinner animation="border" />}
                  </div>
                  {error && <Alert variant="danger">{error}</Alert>}
                  {success && (
                    <Alert variant="success">
                      Form submitted successfully!
                    </Alert>
                  )}
                </div>
                <Grid container spacing={2} justifyContent="center">
                  <Button
                    type="submit"
                    variant="contained"
                    color="success"
                    disabled={loading}
                    style={{ margin: "0.5rem" }}
                  >
                    Submit & Pay
                  </Button>
                </Grid>
              </Form>
            )}
          </Formik>
        </DemoContainer>
      </LocalizationProvider>
      <CarePlanPaymentHandler user={user} userDetails={userDetails} />
      <div style={{ marginTop: "1rem", textAlign: "center" }}>
        <Typography variant="body1">
          Already a user? <Link to="/login">Login</Link>
        </Typography>
      </div>
    </div>
  );
};

export default EventsCarePlan;
